import { makeStyles } from '@material-ui/core/styles'
import { IStyleProps } from './Interface'

export default makeStyles<{}, IStyleProps>({
  root: {},
  label: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 15,
    fontSize: ({ textSize }) => textSize,
    color: ({ textColor }) => textColor
  },
  labelTop: {
    fontSize: '10px',
    color: ({ textColor }) => textColor,
    marginBottom: 5
  }
})
